var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pixel",style:({ background: _vm.background, height: _vm.getPixel(), width: _vm.getPixel() }),attrs:{"id":_vm.id},on:{"click":_vm.changeColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }